import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import Presenter from 'utils/PropTypesPresenter';
import UserPresenter from 'presenters/UserPresenter';
import LoanOfficerPresenter from './LoanOfficerPresenter';
import BuyerPresenter from './BuyerPresenter';

export const buildChatCurrentUser = (user, isOnline) => {
  return {
    id: user.id,
    profileImageUrl: UserPresenter.profileImageUrl(user),
    fullName: UserPresenter.fullName(user),
    firstName: UserPresenter.firstName(user),
    lastName: UserPresenter.lastName(user),
    isOnline,
  };
};

export default new Presenter(
  {
    id: PropTypes.number,
    firebaseChatUid: PropTypes.string,
    loanOfficer: LoanOfficerPresenter.shape(),
    buyer: BuyerPresenter.shape(),
    enabledAutoFollowupsMessages: PropTypes.bool,

    messages: PropTypes.shape(),
    isSubscribed: PropTypes.bool,
    unreadByLoanOfficerCount: PropTypes.number,
    unreadByBuyerCount: PropTypes.number,
    isParticipantOnline: PropTypes.bool,
  },
  {
    buildChatParticipantFromBuyer(buyerId, chat, isOnline) {
      const buyer = isBlank(chat) ? null : this.buyer(chat);

      return {
        id: buyerId,
        profileImageUrl: '',
        isOnline,
        fullName: buyer ? BuyerPresenter.fullName(buyer) : i18n.t(`models.App.userTypes.buyer`),
        phoneNumber: BuyerPresenter.phoneNumber(buyer),
        email: BuyerPresenter.email(buyer),
      };
    },
    buildChatParticipantFromLoanOfficer(loanOfficerId, chat, isOnline) {
      const loanOfficer = isBlank(chat) ? null : this.loanOfficer(chat);

      return {
        id: loanOfficerId,
        profileImageUrl: loanOfficer ? LoanOfficerPresenter.profileImageUrl(loanOfficer) : '',
        fullName: loanOfficer ? LoanOfficerPresenter.fullName(loanOfficer) : i18n.t(`models.App.userTypes.loanOfficer`),
        isOnline,
      };
    },
    getParticipantUid(chat, user) {
      if (UserPresenter.isBuyer(user)) {
        const loanOfficer = this.loanOfficer(chat);
        return loanOfficer.id;
      }
      if (UserPresenter.isLoanOfficer(user)) {
        const buyer = this.buyer(chat);
        return buyer.id;
      }
      return null;
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/ChatPresenter.js